import { css } from '@emotion/react'

export const instructionsContainer = css`
  border-radius: 12px;
  background: #fff;
  padding: 0px 16px;
  gap: 0px;
`

export const successContainer = css`
  padding: 16px;
  display: none;
`
